import React from 'react'

export default function Topbar({ user }) {
  return (
    <header className="topbar">
      <div className="topbar-inner">
        <div className="search">
          <span className="material-symbols-outlined">search</span>
          <input placeholder="Search..." />
        </div>
        <div style={{ display:'flex', gap:8 }}>
          <div className="topbtn"><span className="material-symbols-outlined">notifications</span></div>
          <div className="topbtn"><span className="material-symbols-outlined">help</span></div>
          <div className="topbtn" title={user?.email}><span className="material-symbols-outlined">account_circle</span></div>
        </div>
      </div>
    </header>
  )
}
